import { render, staticRenderFns } from "./pageForm.vue?vue&type=template&id=230be497&scoped=true"
import script from "./pageForm.vue?vue&type=script&lang=js"
export * from "./pageForm.vue?vue&type=script&lang=js"
import style0 from "./pageForm.vue?vue&type=style&index=0&id=230be497&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230be497",
  null
  
)

export default component.exports